import { render, staticRenderFns } from "./VendorManagementPurchasesReports.vue?vue&type=template&id=53f40c81"
import script from "./VendorManagementPurchasesReports.vue?vue&type=script&lang=js"
export * from "./VendorManagementPurchasesReports.vue?vue&type=script&lang=js"
import style0 from "./VendorManagementPurchasesReports.vue?vue&type=style&index=0&id=53f40c81&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports